import ja from '../../lang/ja.json';

export const EnumsMixin = {
        methods: {
            getEnum(class_name) {
                let enums = ja['enums'];
                return enums["App\\Enums\\" + class_name];
            },
            getEnumDescription(class_name, key) {
                let enums = this.getEnum(class_name);
                return enums[key];
            },
            getSortedObject(object) {
                let sorted = {};

                //キーだけ格納し，ソートするための配列生成
                let array = Object.keys(object);

                //配列のソート
                array.sort(function (a, b) {
                    let int_a = +a;
                    let int_b = +b;
                    if (int_a < int_b) {
                        return -1;
                    }
                    if (int_b < int_a) {
                        return 1;
                    }
                    return 0;
                });

                array.forEach(key => {
                    sorted[+key] = {
                        key: key,
                        description: object[key]
                    };
                });

                //戻り値にソート済みのオブジェクトを指定
                return sorted;
            }
        }
    }
;